module.exports = __webpack_public_path__ + "static/media/contacts.0a3b5ca4.jpg";